import IekRedisign from './iek-redisign';
import GenericaRedisign from './generica-redisign';
import ItkRedisign from './itk-redisign';
import OniRedisign from './oni-redisign';
import NewIek from './new-iek';
import NewItk from './new-itk';
import OldItk from './old-itk';
import { TEMPLATE } from '../../config';
import Generica from './generica';
import OldOni from './old-oni';

const templates = {
    iek_redisign: IekRedisign,
    generica_redisign: GenericaRedisign,
    itk_redisign: ItkRedisign,
    oni_redisign: OniRedisign,
    new_iek: NewIek,
    new_itk: NewItk,
    old_itk: OldItk,
    generica: Generica,
    old_oni: OldOni,
};
const Component = templates[TEMPLATE] || (() => <h1>Произошла ошибка</h1>);

// @ts-ignore какой-то баг в тс
export default Component;
